'use client';

import { useEffect } from 'react';
import { handleInitialHashScroll, isBrowser } from 'utils';

/**
 * ScrollToHash component handles smooth scrolling to hash anchors when the page loads.
 * This ensures that URLs with hash fragments (e.g., /service#customer-support) properly scroll
 * to the target element after the DOM is ready.
 *
 * @returns null
 */
export function ScrollToHash() {
  useEffect(() => {
    if (!isBrowser()) return;

    // Handle hash scrolling when DOM is ready
    handleInitialHashScroll();
  }, []);

  return null;
}
